import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { SnapshotsIcon } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { CreateSnapshot } from "@pages/project-details/project-snapshots/create-snapshot";
import { SnapshotsBeingCreatedIndicator } from "@pages/project-details/project-snapshots/snapshots-being-created-indicator";
import { selectedProjectIdSelector, snapshotsBeingCreatedCountSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { TABS_CONTENT_PADDING } from "@utils/ui-utils";
/** Empty page content for snapshots page */
export function SnapshotsEmptyPage(t0) {
  const $ = _c(7);
  const {
    debouncedSearchText
  } = t0;
  const selectedProjectId = useAppSelector(selectedProjectIdSelector);
  const snapshotsBeingCreatedCount = useAppSelector(snapshotsBeingCreatedCountSelector);
  const isCreatingFirstSnapshot = snapshotsBeingCreatedCount > 0;
  let t1;
  if ($[0] !== debouncedSearchText.length || $[1] !== isCreatingFirstSnapshot || $[2] !== selectedProjectId) {
    t1 = debouncedSearchText.length ? <EmptyPage title="No results found" subtitle="There are no snapshots that match this search." icon={SnapshotsIcon} /> : <EmptyPage title="You don't have a snapshot yet" subtitle={isCreatingFirstSnapshot ? <SnapshotsBeingCreatedIndicator /> : "You haven't added snapshots to your project."} icon={SnapshotsIcon} button={selectedProjectId && <CreateSnapshot projectId={selectedProjectId} variant="primary" />} />;
    $[0] = debouncedSearchText.length;
    $[1] = isCreatingFirstSnapshot;
    $[2] = selectedProjectId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const emptyPageContent = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: TABS_CONTENT_PADDING
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== emptyPageContent) {
    t3 = <Box sx={t2}>{emptyPageContent}</Box>;
    $[5] = emptyPageContent;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}